import api from './api';

class ExpedienteService {
  async createExpediente(data) {
    const response = await api.post('/api/expedientes', data);
    return response.data;
  }

  async getExpedientes(filters = {}) {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.cedula) params.append('cedula', filters.cedula);
    if (filters.nombre) params.append('nombre', filters.nombre);
    if (filters.email) params.append('email', filters.email);
    if (filters.cliente_status) params.append('cliente_status', filters.cliente_status);
    if (filters.expediente_status) params.append('expediente_status', filters.expediente_status);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.sort) params.append('sort', filters.sort);

    const response = await api.get(`/api/expedientes?${params.toString()}`);
    return response.data;
  }

  async getExpediente(id) {
    const response = await api.get(`/api/expedientes/${id}`);
    return response.data;
  }

  async updateExpediente(id, data) {
    const response = await api.patch(`/api/expedientes/${id}`, data);
    return response.data;
  }

  async getStatusEnums() {
    const response = await api.get('/api/expedientes/status/enums');
    return response.data;
  }

  async importExcel(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/api/import/excel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async getDashboardStats() {
    const response = await api.get('/api/dashboard/stats');
    return response.data;
  }

  async syncStrapiSingleExpediente(id) {
    const response = await api.post(`/api/expedientes/${id}/sync-strapi-auto`);
    return response.data;
  }

  async deleteExpediente(id) {
    const response = await api.delete(`/api/expedientes/${id}`);
    return response.data;
  }
}

export default new ExpedienteService();
